import type { JSX } from "react";
import type { ChildrenProp } from "@charterindex/armoury-www";
import { NullContextError } from "@charterindex/armoury-www";
import { createContext, useContext, useEffect } from "react";
import { Controller, useController } from "../util/controller";


class PageTitleController extends Controller {
	override initialise(): void {
		document.title = this.services.translation.translate("common:charterIndex");
	}

	setTitle(titleKey: string | null) {
		if(!titleKey) {
			document.title = this.services.translation.translate("common:charterIndexOnline");
			return;
		}

		document.title = this.services.translation.translate(titleKey) + " — " + this.services.translation.translate("common:charterIndexOnline");
	}
}

const pageTitleControllerContext = createContext<PageTitleController | null>(null);

export const PageTitleControllerProvider = ({ children }: ChildrenProp): JSX.Element => {
	const controller = useController(PageTitleController);

	return (
		<pageTitleControllerContext.Provider value={ controller }>
			{ children }
		</pageTitleControllerContext.Provider>
	);
};

/**
 * Sets `document.title`.
 */
export const usePageTitle = (titleKey: string): void => {
	const controller = useContext(pageTitleControllerContext);
	if(!controller) {
		throw new NullContextError("titleControllerContext", "TitleControllerProvider");
	}

	useEffect(() => {
		controller.setTitle(titleKey);
		return () => controller.setTitle(null);
	}, [ controller, titleKey ]);
};